<template>
    <div class="content-body">
        <div class="left-list">
            <div class="left-list-title">
                <div class="color-block"></div>
                <div class="title">栏目</div>
                <div class="color-block end"></div>
            </div>
            <div class="left-list-content">
                <div class="block"></div>
                <div class="splitter"></div>
                <div class="list-content">
                    <div class="content">
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(1)">概述</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(2)">环境</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(3)">自然因素</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(4)">所经历的时代</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <IntroduceView v-if="openIndex == 1"/>
        <EnvironmentView v-if="openIndex == 2"/>
        <DisasterView v-if="openIndex == 3"/>
        <WalkCentury v-if="openIndex == 4" />
    </div>
</template>

<script>
    import IntroduceView from "./IntroduceView";
    import EnvironmentView from "./EnviromentView";
    import DisasterView from "./DisasterView";
    import WalkCentury from "./WalkCentury";
    export default {
        name: "IndexView",
        components: {DisasterView, IntroduceView, EnvironmentView, WalkCentury},
        data() {
            return {
               openIndex: 1
            }
        },
        methods: {
            openPage: function (index) {
                this.openIndex = index
            }
        }
    }
</script>

<style lang="scss" src="../../assets/scss/menu.scss" scoped />